var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_11353)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8536 3.64645C11.6583 3.45118 11.3417 3.45118 11.1464 3.64645C10.9512 3.84171 10.9512 4.15829 11.1464 4.35355L14.2929 7.5H5.5C5.22386 7.5 5 7.72386 5 8C5 8.27614 5.22386 8.5 5.5 8.5H14.2929L11.1464 11.6464C10.9512 11.8417 10.9512 12.1583 11.1464 12.3536C11.3417 12.5488 11.6583 12.5488 11.8536 12.3536L15.8536 8.35355C15.9015 8.30561 15.9377 8.25036 15.9621 8.19139C15.9842 8.13777 15.9967 8.08107 15.9994 8.02399C15.9998 8.016 16 8.008 16 8M15.9621 7.80861C15.9377 7.74964 15.9015 7.69439 15.8536 7.64645L11.8536 3.64645M15.9621 7.80861C15.9861 7.86669 15.9996 7.9303 16 7.997L15.9621 7.80861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.5H2C1.60218 15.5 1.22064 15.342 0.93934 15.0607C0.658035 14.7794 0.5 14.3978 0.5 14V2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5H8.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_11353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.d81f2036d38c861cd1785a5e3053180b.svg";
export { ForwardRef as ReactComponent };